export const VALUE_PROPS = [
  {
    title: '3 out of 4 people',
    description: 'with depression or anxiety feel better within 3 months',
    footnote: true,
  },
  {
    title: '96% of patients',
    description: 'feel supported and understood by their therapist',
    footnote: true,
  },
  {
    title: '4 out of 5 patients',
    description: 'continue care beyond their first session',
    footnote: true,
  },
] as const
